import { createActionId, sessionRecord } from '../platform/session/session';
import { emit } from '../platform/events/lifecycle';
import { getCanonicalPageType } from './utils/window-utils';
import { MAGIC_APRON_ASSISTANT_ORIGIN, HEADER_ENTRY } from './assistant-config';

// The shape analytics parses out of `submit-click`, shared by both producers:
//   maa:<entry location>:<page type>:<message origin>:<question>
export const buildAnalyticsQuestion = ({
  entryLocation, pageType, messageOrigin, userQuestion,
}) => [
  MAGIC_APRON_ASSISTANT_ORIGIN,
  entryLocation,
  pageType,
  messageOrigin,
  userQuestion,
].filter(Boolean).join(':');

export const emitHeaderEntryClick = (interactionLabel) => {
  const { sessionId } = sessionRecord.get() ?? {};
  emit(HEADER_ENTRY.SUBMIT_EVENT, {
    actionID: createActionId(sessionId),
    sessionID: sessionId,
    question: buildAnalyticsQuestion({
      entryLocation: HEADER_ENTRY.ENTRY_LOCATION,
      pageType: String(getCanonicalPageType()).toLowerCase(),
      messageOrigin: HEADER_ENTRY.MESSAGE_ORIGIN,
      userQuestion: interactionLabel,
    }),
  });
};
